module.exports = __webpack_public_path__ + "img/trader_joes.a2bac74a.png";